import type { SessionTranslations } from "../../types/session";

export const session: SessionTranslations = {
  expired: "Teie sessioon on aegunud",
  expiresSoon: "Teie sessioon aegub varsti",
  stayLoggedIn: "Jää Sisseloginuks",
  logout: "Logi välja",
  timeRemaining: "Järelejäänud aeg",
  timeoutWarningTitle: "Sessiooni Aegumise Hoiatus",
  timeoutWarningMessage:
    "Teie sessioon on tegevusetuse tõttu aegumas. Töö jätkamiseks klõpsake 'Jää Sisseloginuks'.",
  timeoutCountdown: "Järelejäänud {seconds} sekundit",
  logoutNow: "Logi Välja Kohe",
};
